import { useMemo } from 'react';

export const useInView = (callBack = () => {}, options = {}) =>
  useMemo(
    () => new IntersectionObserver(callBack, options),
    [callBack, options]
  );
